import type { HeroRotator, HeroRotatorGame } from '@nimbus/types'

/** Manually ordered top games the rotator shows on every brand that doesn't set its own `fallbackGames`. */
export const DEFAULT_HERO_ROTATOR_GAMES: HeroRotatorGame[] = [
    { slug: 'flaming-tiger' },
    { slug: 'zodiac-signs' },
    { slug: 'big-bait' },
    { slug: 'midnight-bingo' },
    { slug: 'big-bass-bonanza' },
    { slug: 'safari-blitz' },
    { slug: 'diamond-express' },
    { slug: 'blazing-dragon' },
    { slug: 'golden-pyramid' },
    { slug: 'castle-of-cards' },
]

/** The brand's rotator games; empty when it has no rotator, so those brands never fetch the default list. */
export function heroRotatorGames(config: HeroRotator | undefined): HeroRotatorGame[] {
    if (!config) return []

    const games = [...(config.fallbackGames ?? DEFAULT_HERO_ROTATOR_GAMES), ...(config.extraGames ?? [])]

    // A repeated slug would render the same game as two tiles.
    return games.filter((game, index) => games.findIndex(other => other.slug === game.slug) === index)
}
